import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';

import config from '../../config';
import { withPermissions, permissions } from '../../shared/authorization';
import columnDefinitions from '../../shared/columnDefinitions/taxRates';
import { adminPageNames, adminPageTitles } from '../shared/adminPageNames';
import AdminImportPage from '../shared/adminImportPage.component';

import AddTaxRateModal from './addTaxRateModal.component';
import DeleteTaxRateModal from './deleteTaxRateModal.component';
import downloadTaxRatesXlsx from './downloadTaxRatesXlsx';
import { sharedActions } from './store/actions';
import TaxRatesAdminColumnRenderer from './taxRatesAdminColumnRenderer.component';

const TaxRatesPage = ({
  canModifyInSelectedPeriod,
}) => {
  const generateTemplateFileName = useCallback(
    ({ periodName }) => `TLS_Tax_Rate_${periodName}`,
    []);

  const idFieldComparator = useCallback((taxRate, importedTaxRate) => (
    taxRate.companyCode === importedTaxRate.companyCode
    && taxRate.countryTaxType === importedTaxRate.countryTaxType
    && taxRate.countryCode === importedTaxRate.countryCode
  ), []);

  return (
    <div>
      <ReactTooltip/>
      <AdminImportPage
        pageName={adminPageNames.TAX_RATES}
        canModify={canModifyInSelectedPeriod}
        AddEditEntityModal={AddTaxRateModal}
        RemoveEntityModal={DeleteTaxRateModal}
        adminColumnRenderer={TaxRatesAdminColumnRenderer}
        addEntityMessage="Add Tax Rate"
        columnDefs={columnDefinitions}
        actions={sharedActions}
        exportToExcel={downloadTaxRatesXlsx}
        generateTemplateFileName={generateTemplateFileName}
        templatePath={config.templates.TAX_RATES}
        comparatorConfig={{
          idField: 'countryTaxType',
          idFieldComparator,
        }}
        pageTitle={adminPageTitles.TAX_RATES}
      />
    </div>
  );
};

TaxRatesPage.propTypes = {
  canModifyInSelectedPeriod: PropTypes.bool.isRequired,
};


export default withPermissions(permissions.TAX_RATES)(TaxRatesPage);
